<template>
  <div class="share-link">
    <span class="share-link-label">{{ label }}</span>
    <div class="share-link-row">
      <input class="share-link-input" :value="url" readonly />
      <button type="button" class="btn btn-secondary" @click="copyUrl">
        {{ copied ? 'Скопировано' : 'Копировать' }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  url: {
    type: String,
    required: true,
  },
})

const copied = ref(false)

async function copyUrl() {
  try {
    await navigator.clipboard.writeText(props.url)
    copied.value = true
    setTimeout(() => {
      copied.value = false
    }, 2000)
  } catch {
    copied.value = false
  }
}
</script>

<style scoped>
.share-link + .share-link {
  margin-top: 0.75rem;
}

.share-link-label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
  color: #64748b;
}

.share-link-row {
  display: flex;
  gap: 0.5rem;
}

.share-link-input {
  flex: 1;
  min-width: 0;
}
</style>
